export default {
  title: 'Topitems',
  columns: {
    name: 'Naam',
    quantity: 'Aantal',
    amount: 'Bedrag',
  },
};
